/* Star Kagune — Anime collection search/filter on /collections page */
(function () {
  'use strict';

  // Only run on the /collections list page
  if (!/^\/collections\/?$/.test(location.pathname)) return;

  function init() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('.tile-wrapper'));
    if (!tiles.length) return;

    // Find the parent grid of the first tile-wrapper
    var firstGrid = tiles[0].closest('.grid') || tiles[0].parentNode;
    if (!firstGrid || document.getElementById('sk-coll-search')) return;

    // Build a label index: tile -> normalized search text
    tiles.forEach(function (t) {
      var label = t.querySelector('.collection-label');
      var text = (label && label.textContent || t.innerText || '').trim().toLowerCase();
      var alt = '';
      var a = t.querySelector('a[href*="/collections/"]');
      if (a) alt = ((a.getAttribute('aria-label') || '') + ' ' + (a.getAttribute('href') || '')).toLowerCase();
      t.dataset.skSearch = (text + ' ' + alt).replace(/\s+/g, ' ').trim();
    });

    // Build search input
    var wrap = document.createElement('div');
    wrap.id = 'sk-coll-search';
    wrap.innerHTML = [
      '<div class="sk-coll-search__inner">',
      '  <svg class="sk-coll-search__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="M21 21l-4.35-4.35"></path></svg>',
      '  <input type="search" id="sk-coll-search-input" placeholder="Search anime..." autocomplete="off" aria-label="Search anime collections">',
      '  <button type="button" id="sk-coll-search-clear" aria-label="Clear search" hidden>&times;</button>',
      '</div>',
      '<div class="sk-coll-search__empty" hidden>No matches — try a different name</div>'
    ].join('');

    firstGrid.parentNode.insertBefore(wrap, firstGrid);

    var input = wrap.querySelector('#sk-coll-search-input');
    var clearBtn = wrap.querySelector('#sk-coll-search-clear');
    var emptyMsg = wrap.querySelector('.sk-coll-search__empty');

    function applyFilter() {
      var q = input.value.trim().toLowerCase();
      clearBtn.hidden = !q;
      var visible = 0;
      tiles.forEach(function (t) {
        var match = !q || t.dataset.skSearch.indexOf(q) >= 0;
        t.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      emptyMsg.hidden = visible > 0;
    }

    input.addEventListener('input', applyFilter);

    // Press Enter → jump to first visible match
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var firstVisible = tiles.find(function (t) { return t.style.display !== 'none' && t.dataset.skSearch; });
      if (!firstVisible) return;
      var link = firstVisible.querySelector('a[href*="/collections/"]');
      if (link) location.href = link.href;
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      applyFilter();
      input.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
